import { BaseHTMLAttributes, CSSProperties } from 'react';

export function div(styleOrClassName: CSSProperties | string) {
  return (p: BaseHTMLAttributes<object>) =>
    typeof styleOrClassName === 'string' ? (
      <div className={styleOrClassName} {...p} />
    ) : (
      <div style={styleOrClassName} {...p} />
    );
}
